import { useState } from 'react'

import type { BundleCard } from '@space-core/components/customCard/bundle/types'

import BundleContext from './context'

import type { BundleProviderProps } from './types'

const BundleProvider = ({ children }: BundleProviderProps) => {
  const [bundle, setBundle] = useState<BundleCard>({} as BundleCard)

  const handleSetBundle = (bundle: BundleCard) => {
    setBundle(bundle)
  }

  return (
    <BundleContext.Provider
      value={{
        bundle,
        methods: {
          setBundle: handleSetBundle
        }
      }}>
      {children}
    </BundleContext.Provider>
  )
}

export default BundleProvider
